import { useProductDetails } from '@app/pdp/hooks/useProductDetails';
import { getLocale, getCurrency } from '@libs/core';
import { getAfterpayConfig } from '@libs/common-next';
import './Afterpay.scss';

export default function AfterPay() {
    const { selectedProduct } = useProductDetails();
    const category = selectedProduct.categoryAssignments?.primary.name;
    const selectedPrice = selectedProduct?.price;
    const locale = getLocale();
    const { mpid, placementId } = getAfterpayConfig();

    const currency = getCurrency();

    const afterPayPriceRange = (productPrice: number) =>
        productPrice >= 1 && productPrice <= 2000;

    return (
        <div
            data-testid="afterpay"
            className="after-pay-container"
            // eslint-disable-next-line react/no-danger -- custom Afterpay html element
            dangerouslySetInnerHTML={{
                __html: `
                <square-placement
                    data-mpid="${mpid}"
                    data-placement-id="${placementId}"
                    data-page-type="PDP"
                    data-modal-id="${locale.replace('-', '_')}-petsmart"
                    data-amount="${selectedPrice?.number ?? ''}"
                    data-currency="${currency}"
                    data-consumer-locale="${locale}"
                    data-item-skus="${selectedProduct.id}"
                    data-item-categories="${category ?? ''}"
                    data-is-eligible="${
                        selectedPrice?.number
                            ? afterPayPriceRange(selectedPrice.number)
                            : ''
                    }"
                    >
                </square-placement>
            `,
            }}
        />
    );
}
